// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/LgpdTerms_DeleteResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for POST /lgpd_terms/delete
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface LgpdTerms_DeleteResponseDados {
id: number
}

export type LgpdTerms_DeleteResponse = ApiResponse<LgpdTerms_DeleteResponseDados>;

registerResponseContract('LgpdTerms_DeleteResponse', {
  id: { type: 'number',  required: true },
})
